"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _constants = require("@seedlang/constants");
var _layouts = require("@seedlang/layouts");
var _stores = require("@seedlang/stores");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
var _mobx = require("mobx");
var _root_state = _interopRequireDefault(require("./root_state"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
// remember: don't include AppUI in a UI file

var targetLanguageFilters = ['vocabLevelId', 'vocabWordTypeId', 'vocabLearned', 'vocabReviewing', 'vocabHasSentence', 'vocabHasHighlightedVocabTriad', 'vocabSeen', 'vocabLanguagesWithWithout'];
var SEARCH_DEBOUNCE_MS = 700;
var SEARCH_MAX_CHARACTERS = 100;
var SEARCH_MIN_CHARACTERS = 2;
var VocabUI = (_class = /*#__PURE__*/function (_RootState) {
  function VocabUI(parent) {
    var _this;
    _classCallCheck(this, VocabUI);
    _this = _callSuper(this, VocabUI);
    _initializerDefineProperty(_this, "filterCache", _descriptor, _this);
    _initializerDefineProperty(_this, "selectedWords", _descriptor2, _this);
    _initializerDefineProperty(_this, "caretPosition", _descriptor3, _this);
    _initializerDefineProperty(_this, "allToggleSelected", _descriptor4, _this);
    _initializerDefineProperty(_this, "userRequestIsPending", _descriptor5, _this);
    _initializerDefineProperty(_this, "targetLanguageRequestIsPending", _descriptor6, _this);
    _initializerDefineProperty(_this, "queuedUserData", _descriptor7, _this);
    _initializerDefineProperty(_this, "queuedTargetLanguageData", _descriptor8, _this);
    _initializerDefineProperty(_this, "vocabTab", _descriptor9, _this);
    _initializerDefineProperty(_this, "tabsPreviouslyTrainers", _descriptor0, _this);
    _initializerDefineProperty(_this, "deckId", _descriptor1, _this);
    _initializerDefineProperty(_this, "worksheetId", _descriptor10, _this);
    _initializerDefineProperty(_this, "cardTypeId", _descriptor11, _this);
    _initializerDefineProperty(_this, "filteredItemsCount", _descriptor12, _this);
    _initializerDefineProperty(_this, "showFilterOptions", _descriptor13, _this);
    _initializerDefineProperty(_this, "overridePage", _descriptor14, _this);
    _initializerDefineProperty(_this, "pageFromParams", _descriptor15, _this);
    _initializerDefineProperty(_this, "learnedByLevel", _descriptor16, _this);
    _initializerDefineProperty(_this, "learnedByLevelLoading", _descriptor17, _this);
    _initializerDefineProperty(_this, "updatedDeviceLanguageId", _descriptor18, _this);
    _this.currentWordsRequest = void 0;
    _this.currentWordsRequestKey = void 0;
    _initializerDefineProperty(_this, "targetLanguageId", _descriptor19, _this);
    _initializerDefineProperty(_this, "defaultReviewDeckId", _descriptor20, _this);
    _initializerDefineProperty(_this, "newReviewDeckName", _descriptor21, _this);
    _initializerDefineProperty(_this, "createReviewsIsSlow", _descriptor22, _this);
    _initializerDefineProperty(_this, "createReviewsFinished", _descriptor23, _this);
    _initializerDefineProperty(_this, "wordVideoClips", _descriptor24, _this);
    _initializerDefineProperty(_this, "wordListLoading", _descriptor25, _this);
    _this.onSetDeckId = function (deckId) {
      _this.deckId = deckId;
    };
    _this.clearFilterCache = function () {
      _this.filterCache = {};
    };
    _this.setShowFilterOptions = function (showFilterOptions) {
      _this.showFilterOptions = showFilterOptions;
    };
    _this.updateMultipleSelectFilter = function (key, value) {
      if ((0, _utils.isBlank)(value) || !_this.user[key] && !_this.targetLanguage[key]) {
        _this.filterCache[key] = [];
      } else if ((0, _utils.isBlank)(_this.filterCache[key])) {
        var backendValue = _this.filterCacheOrBackend(key);
        if ((0, _lodash.isArray)(backendValue)) {
          _this.filterCache[key] = backendValue;
        } else if ((0, _lodash.isString)(backendValue)) {
          _this.filterCache[key] = backendValue.split(',').filter(function (item) {
            return !(0, _utils.isBlank)(item);
          });
        } else {
          _this.filterCache[key] = [];
        }
      }
      if ((0, _utils.isPresent)(value)) {
        _this.filterCache[key] = (0, _lodash.xor)(_this.filterCache[key], [value]);
      }
    };
    _this.keyIsMultiSelect = function (key) {
      var _this$filterSettings$;
      return (_this$filterSettings$ = _this.filterSettings.find(function (item) {
        return item.userKey === key;
      })) === null || _this$filterSettings$ === void 0 ? void 0 : _this$filterSettings$.multiSelect;
    };
    _this.arrayToOptions = function (object, field) {
      return object.map(function (item) {
        return [item.id, item[field]];
      });
    };
    _this.filterCacheOrBackend = function (field) {
      if (field in _this.filterCache) {
        return _this.filterCache[field];
      } else if (targetLanguageFilters.includes(field)) {
        return _this.targetLanguage[field];
      } else if ((0, _utils.isPresent)(_this.user[field])) {
        return _this.user[field];
      }
    };
    _this.onSetNewReviewDeckName = function (newReviewDeckName) {
      _this.newReviewDeckName = newReviewDeckName;
    };
    _this.onCreateNewReviewDeck = function (callback) {
      if ((0, _utils.isBlank)(_this.newReviewDeckName)) {
        return;
      }
      var data = {
        userId: _this.user.id,
        deckType: 'review',
        name: _this.newReviewDeckName,
        defaultReviewDeck: true,
        languageId: _this.user.targetLanguageId
      };
      _this.deckStore.create({
        data: data
      }, callback);
      _this.newReviewDeckName = '';
    };
    _this.onSetFilter = function (key, value, params) {
      var multiSelect = _this.keyIsMultiSelect(key);
      if (key === 'selectedWords') {
        _this.selectedWords = [];
      } else if (key === 'languageId') {
        _this.wordStore.clearIndexData();
      } else if (multiSelect) {
        _this.updateMultipleSelectFilter(key, value);
      } else {
        _this.filterCache[key] = value;
      }
      _this.overridePage = 1;
      var callback = !params || !params['skipGetWords'] ? _this.getWords : _lodash.noop;
      if (key !== 'selectedWords' && key !== 'vocabSearchQuery') {
        var data = {};
        data[key] = multiSelect ? _this.filterCache[key].filter(function (item) {
          return !(0, _utils.isBlank)(item);
        }).join(',') : value;
        if (key === 'vocabLanguagesWithWithout') {
          _this.filterCache['vocabLanguagesEnable'] = (0, _utils.isPresent)(value);
          data['vocabLanguagesEnable'] = (0, _utils.isPresent)(value);
        }
        _this.updateUserAndTargetLanguage(data, callback);
      }
      if (key === 'vocabHasSentence') {
        _this.getLearnedByLevel();
      }
      _this.updateCardType();
    };
    _this.getLearnedByLevel = function (languageId) {
      _this.learnedByLevelLoading = true;
      var params = {
        queryStrings: {
          words_have_sentences: _this.user.vocabHasSentence,
          word_type_id: _this.user.vocabWordTypeId,
          language_id: languageId
        },
        failureCallback: function failureCallback() {
          _this.learnedByLevelLoading = false;
        }
      };
      _this.dashboardStore.api(params, function (resp) {
        _this.afterGetKnownByLevel(resp);
        _this.learnedByLevelLoading = false;
      }, 'GET', 'learnedByLevel');
    };
    _this.afterGetKnownByLevel = function (resp) {
      _this.learnedByLevel = resp;
    };
    _this.setWord = function (word) {
      _stores.WordStore.setShowData(word);
      var userTranslationData = {
        viewsCount: word.viewsCount,
        learned: word.learned,
        reviewing: word.reviewing,
        userTranslationId: word.userTranslationId,
        consecutiveGoodScores: word.consecutiveGoodScores
      };
      if (word.hasDictionaryConcept || word.hasRelatedWords) {
        _stores.WordStore.getShow({
          ids: {
            wordId: word.id
          }
        }, function (resp) {
          return _this.afterSetWord(resp, userTranslationData);
        });
      }
    };
    _this.afterSetWord = function (resp, userTranslationData) {
      var wordWithUserTranslationData = _objectSpread(_objectSpread({}, resp), userTranslationData);
      _stores.WordStore.setShowData(wordWithUserTranslationData);
    };
    _this.setPageFromParams = function (pageFromParams) {
      _this.pageFromParams = pageFromParams;
      if ((0, _utils.isPresent)(pageFromParams)) {
        _this.overridePage = null;
      }
    };
    _this.setDefaultReviewDeckId = function (defaultReviewDeckId) {
      _this.defaultReviewDeckId = defaultReviewDeckId;
    };
    _this.updateUserAndTargetLanguage = function (data, callback) {
      var targetLanguageUpdatedFilters = {};
      var userUpdatedFilters = {};
      (0, _lodash.each)((0, _lodash.keys)(data), function (key) {
        if (targetLanguageFilters.includes(key)) {
          targetLanguageUpdatedFilters[key] = data[key];
          if (_this.targetLanguageRequestIsPending) {
            _this.queuedTargetLanguageData[key] = data[key];
          }
        } else {
          userUpdatedFilters[key] = data[key];
          if (_this.user) {
            _this.user.set(key, data[key]);
          }
          if (_this.userRequestIsPending) {
            _this.queuedUserData[key] = data[key];
          }
        }
      });
      if ((0, _lodash.keys)(targetLanguageUpdatedFilters).length > 0) {
        if (!_this.targetLanguageRequestIsPending) {
          _this.targetLanguageRequestIsPending = true;
          if (callback) {
            _this.callback = callback;
          }
          _this.targetLanguageStore.update({
            data: targetLanguageUpdatedFilters,
            ids: {
              languageId: _this.targetLanguageId,
              userId: _this.user.id
            }
          }, _this.afterUpdateTargetLanguage);
        }
      }
      if ((0, _lodash.keys)(userUpdatedFilters).length > 0) {
        if (!_this.userRequestIsPending) {
          _this.userRequestIsPending = true;
          if (callback) {
            _this.callback = callback;
          }
          _this.authUserStore.update({
            data: data
          }, _this.afterUpdateUser); // heritage: keep updating user vocab filters for heritage mobile apps
        }
      }
    };
    _this.loadUser = function (callback, device) {
      _this.authUserStore.getShow({
        queryStrings: {
          device_language_id: _this.deviceLanguageId,
          device: device || _this.layout.device
        }
      }, callback);
    };
    _this.afterUpdateUser = function () {
      _this.userRequestIsPending = false;
      if ((0, _utils.isPresent)(_this.queuedUserData)) {
        _this.updateUserAndTargetLanguage(_this.queuedUserData);
        _this.queuedUserData = {};
      } else {
        if (_this.callback) {
          _this.callback();
          _this.loadUser();
          _this.callback = null;
        }
      }
    };
    _this.afterUpdateTargetLanguage = function () {
      _this.targetLanguageRequestIsPending = false;
      if ((0, _utils.isPresent)(_this.queuedTargetLanguageData)) {
        _this.updateUserAndTargetLanguage(_this.queuedTargetLanguageData);
        _this.queuedTargetLanguageData = {};
      } else {
        if (_this.callback) {
          _this.callback();
          _this.loadUser();
          _this.callback = null;
        }
      }
    };
    _this.onSetTargetLanguageId = function (targetLanguageId) {
      _this.targetLanguageId = targetLanguageId;
    };
    _this.updateLearnedByLevel = function (level, field, increment) {
      if (_this.learnedByLevel) {
        var obj = _this.learnedByLevel.find(function (item) {
          return item.label === level;
        });
        if (obj) {
          obj[field] += increment;
        }
      }
    };
    _this.onToggleLearned = function (word) {
      if (!word) {
        return;
      }
      if (word.set) {
        word.set('learned', !word.learned);
      } else {
        word.learned = !word.learned;
      }
      var increment = word.learned ? 1 : -1;
      var levelAbbreviation = word.level && word.level.abbreviation;
      if (levelAbbreviation) {
        _this.updateLearnedByLevel(levelAbbreviation, 'learned', increment);
      }
      if (word.learned) {
        if (word.set) {
          word.set('reviewing', false);
        } else {
          word.reviewing = false;
        }
        _this.wordStore.incrementMetaData('reviewsCount', -1);
      }
      _this.wordStore.incrementMetaData('learnedCount', increment);
      _this.createOrUpdateUserTranslation(word, {
        learned: word.learned
      }, _this.afterCreateUserTranslation.bind(_this, word));
    };
    _this.createOrUpdateUserTranslation = function (word, data, callback) {
      if (word.userTranslationId) {
        _this.userTranslationStore.update({
          data: data,
          ids: {
            userTranslationId: word.userTranslationId
          }
        });
      } else {
        data.translationId = word.root ? word.id : word.rootWordId;
        _this.userTranslationStore.create({
          data: data
        }, callback);
      }
    };
    _this.afterCreateUserTranslation = function (word, resp) {
      if (word.set) {
        word.set('userTranslationId', resp.userTranslationId);
      } else {
        word.userTranslationId = resp.userTranslationId;
      }
    };
    _this.afterSubmitSourceInput = function () {
      _this.set('wordListLoading', true);
      _this.wordStore.reloadIndexFiltered({
        queryStrings: {
          vocab_list: true
        },
        callback: function callback(resp) {
          try {
            _this.wordStore.afterGetIndex(resp);
          } finally {
            _this.set('wordListLoading', false);
          }
        }
      });
    };
    _this.clearSelectedWords = function () {
      _this.selectedWords = [];
    };
    _this.getWords = function () {
      var _this$currentWordsReq;
      _this.set('wordListLoading', true);
      _this.filteredItemsCount = null;
      _this.wordStore.clearFilter();
      _this.wordStore.setPage(_this.page);
      var filtersForRequest = (0, _lodash.cloneDeep)(_this.filters);
      var requestKey = {
        filters: filtersForRequest,
        page: _this.page,
        sort: _this.sortWithDirection
      };
      if ((_this$currentWordsReq = _this.currentWordsRequest) !== null && _this$currentWordsReq !== void 0 && _this$currentWordsReq.abort) {
        _this.currentWordsRequest.abort();
      }
      _this.currentWordsRequestKey = requestKey;
      var finishRequest = function finishRequest() {
        if (_this.currentWordsRequestKey === requestKey) {
          _this.currentWordsRequest = null;
          _this.set('wordListLoading', false);
        }
      };
      var request = _this.wordStore.getIndex({
        queryStrings: {
          vocab_list: true
        },
        sort: _this.sortWithDirection,
        filters: filtersForRequest,
        failureCallback: finishRequest,
        onRequestError: finishRequest
      }, function (resp) {
        try {
          _this.afterGetWords(resp, requestKey);
        } finally {
          finishRequest();
        }
      });
      _this.currentWordsRequest = request;
    };
    _this.afterGetWords = function (resp, requestKey) {
      if ((0, _lodash.isEqual)(requestKey, _this.currentWordsRequestKey)) {
        _this.wordStore.setIndexData(resp);
        if (resp.meta) {
          _this.filteredItemsCount = resp.meta.totalCount;
        }
        if ((0, _utils.isPresent)(requestKey.filters.target_text)) {
          var dictionarySearchResultsCount = _this.wordStore.indexData.length;
          _this.createEvent('vocab - search', {
            context: 'vocab',
            results_count: dictionarySearchResultsCount,
            target_language_id: _this.targetLanguageId
          });
        }
      }
    };
    _this.onUpdateSearchQuery = function (value, caretPosition) {
      var limitedValue = (0, _utils.isPresent)(value) ? Array.from(value).slice(0, SEARCH_MAX_CHARACTERS).join('') : value;
      if ((0, _utils.isBlank)(_this.searchQuery) && (0, _utils.isPresent)(limitedValue) && _this.vocabTab === 'trainers') {
        _this.tabsPreviouslyTrainers = true;
        _this.onSetVocabTab('wordList');
      } else if ((0, _utils.isPresent)(_this.searchQuery) && (0, _utils.isBlank)(limitedValue) && _this.tabsPreviouslyTrainers) {
        _this.tabsPreviouslyTrainers = false;
        _this.onSetVocabTab('trainers');
      }
      _this.onSetFilter('vocabSearchQuery', limitedValue, {
        skipGetWords: true
      });
      _this.caretPosition = (0, _utils.isPresent)(caretPosition) ? Math.min(caretPosition, limitedValue ? limitedValue.length : 0) : caretPosition;
      clearInterval(_this.interval);
      var normalizedValue = limitedValue ? limitedValue.trim() : '';
      if ((0, _utils.isBlank)(normalizedValue) || normalizedValue.length >= SEARCH_MIN_CHARACTERS) {
        _this.interval = setTimeout(_this.getWords, SEARCH_DEBOUNCE_MS);
      }
    };
    _this.insertText = function (text, caretPosition) {
      var newValue;
      if (!caretPosition) {
        caretPosition = _this.searchQuery ? _this.searchQuery.length : 0;
      }
      if (_this.disabled) {
        return;
      }
      if (_this.searchQuery) {
        newValue = [_this.searchQuery.slice(0, caretPosition), text, _this.searchQuery.slice(caretPosition)].join('');
      } else {
        newValue = text;
      }
      _this.onUpdateSearchQuery(newValue, caretPosition + 1);
    };
    _this.onToggleAddWordToDeck = function (word, params) {
      if (_this.user.isMember || (0, _utils.isPresent)(params) && params['alwaysAllow']) {
        _this.selectedWords = (0, _lodash.xor)(_this.selectedWords, [word]);
        _this.updateCardType();
      }
    };
    _this.updateCardType = function () {
      var cardTypeOptionsIds = _this.cardTypeOptions.map(function (option) {
        return option[0];
      });
      if (!cardTypeOptionsIds.includes(_this.cardTypeId)) {
        _this.cardTypeId = _this.cardTypeOptions[0][0];
      }
    };
    _this.onToggleExpandTranslation = function () {
      _this.onSetFilter('vocabExpandTranslation', !_this.expandTranslation);
    };
    _this.onToggleAddAllToDeck = function () {
      _this.allToggleSelected = !_this.allToggleSelected;
      if (_this.allToggleSelected) {
        (0, _lodash.each)(_this.words, function (word) {
          if (!_this.selectedWords.find(function (item) {
            return item.id === word.id;
          })) {
            _this.selectedWords.push(word);
          }
        });
      } else {
        (0, _lodash.each)(_this.words, function (word) {
          _this.selectedWords = _this.selectedWords.filter(function (item) {
            return item.id !== word.id;
          });
        });
      }
      _this.updateCardType();
    };
    _this.reviewCreationSource = function (params) {
      var interfaceSource = (0, _utils.isPresent)(params) && (0, _utils.isPresent)(params['interfaceSource']) ? params['interfaceSource'] : 'vocab-list';
      return interfaceSource === 'vocab-list' ? 'dictionary' : interfaceSource;
    };
    _this.reviewCardTypeSlug = function (cardTypeId) {
      var _Constants$REVIEW_CAR;
      return (_Constants$REVIEW_CAR = _constants.Constants.REVIEW_CARD_TYPES.find(function (item) {
        return item.id === cardTypeId;
      })) === null || _Constants$REVIEW_CAR === void 0 ? void 0 : _Constants$REVIEW_CAR.slug;
    };
    _this.addedReviewsEventParams = function (params) {
      return {
        review_creation_source: _this.reviewCreationSource(params),
        interface_source: (0, _utils.isPresent)(params) && (0, _utils.isPresent)(params['interfaceSource']) ? params['interfaceSource'] : 'vocab-list',
        card_type: _this.reviewCardTypeSlug(_this.cardTypeId),
        deck_id: _this.deckId || _this.defaultReviewDeckId,
        language_id: (0, _utils.isPresent)(params) && params['languageId'] ? params['languageId'] : _this.targetLanguageId,
        review_count: _this.selectedWordIds.length
      };
    };
    _this.onCreateReviews = function (params) {
      if (!_this.deckButtonDisabled) {
        _this.allToggleSelected = false;
        _this.pendingAddedReviewsEventParams = _this.addedReviewsEventParams(params);
        _this.cardStore.create({
          data: {
            interface_source: (0, _utils.isPresent)(params) && (0, _utils.isPresent)(params['interfaceSource']) ? params['interfaceSource'] : 'vocab-list',
            word_ids: _this.selectedWordIds,
            deck_id: _this.deckId || _this.defaultReviewDeckId,
            cardTypeId: _this.cardTypeId,
            languageId: (0, _utils.isPresent)(params) && params['languageId']
          }
        }, _this.afterCreateReviews);
        setTimeout(function () {
          if (!_this.createReviewsFinished) {
            _this.createReviewsIsSlow = true;
            _this.selectedWords = [];
            setTimeout(function () {
              return _this.createReviewsIsSlow = false;
            }, 5000);
          }
        }, 1000);
      }
    };
    _this.afterCreateReviews = function () {
      if (_this.pendingAddedReviewsEventParams) {
        _this.createEvent('reviews - add review', _this.pendingAddedReviewsEventParams);
        _this.pendingAddedReviewsEventParams = null;
      }
      _this.createReviewsFinished = true;
      _this.deckIsBeingCreated = false;
      _this.createReviewsIsSlow = false;
      _this.selectedWords = [];
      setTimeout(function () {
        return _this.createReviewsFinished = false;
      }, 5000);
    };
    _this.onClickSort = function (sort) {
      var sortDirection;
      if (_this.sort === sort) {
        sortDirection = _this.sortDirection === 'desc' ? 'asc' : 'desc';
      } else {
        sortDirection = 'asc';
      }
      _this.onSetFilter('vocabSort', sort, {
        skipGetWords: true
      });
      _this.onSetFilter('vocabSortDirection', sortDirection);
      _this.getWords();
    };
    _this.onSetVocabTab = function (vocabTab) {
      _this.vocabTab = vocabTab;
      _this.user.set('vocabTab', vocabTab);
      _this.updateUserAndTargetLanguage({
        vocabTab: vocabTab
      }, _lodash.noop);
    };
    _this.onSetCardTypeId = function (cardTypeId) {
      _this.cardTypeId = cardTypeId;
    };
    _this.addWordVideoClip = function (wordId, videoClip) {
      _this.wordVideoClips[wordId] = videoClip;
    };
    _this.parent = parent;
    _this.layout = new _layouts.AppLayout(_this);
    _this.authUserStore = _stores.AuthUserStore;
    _this.targetLanguageStore = _stores.TargetLanguageStore;
    _this.wordTypeStore = _stores.WordTypeStore;
    _this.reviewDeckStore = _stores.ReviewDeckStore;
    _this.deckStore = _stores.DeckStore;
    _this.userTranslationStore = _stores.UserTranslationStore;
    _this.cardStore = _stores.CardStore;
    _this.wordStore = _stores.WordStore;
    _this.worksheetWordStore = _stores.WorksheetWordStore;
    _this.dashboardStore = _stores.DashboardStore;
    _this.eventStore = _stores.EventStore;
    return _this;
  }
  _inherits(VocabUI, _RootState);
  return _createClass(VocabUI, [{
    key: "store",
    get: function get() {
      if (this.worksheetId) {
        return this.worksheetWordStore;
      } else {
        return this.wordStore;
      }
    }
  }, {
    key: "words",
    get: function get() {
      if (this.worksheetId && this.worksheetWordStore.hasIndexData) {
        return this.worksheetWordStore.indexData.map(function (item) {
          return item.word;
        });
      } else {
        return this.wordStore.indexData;
      }
    }
  }, {
    key: "noFiltersSelectedMessage",
    get: function get() {
      var messages = {
        'frequency_ranking': 'No Filter Selected. Sorted By Most Frequent.',
        '-frequency_ranking': 'No Filter Selected. Sorted By Least Frequent.',
        'target_text': 'No Filter Selected. Sorted Alphabetically.',
        '-target_text': 'No Filter Selected. Sorted Reverse Alphabetically.'
      };
      return this.layout.isNative ? 'No Filter Selected.' : messages[this.sortWithDirection || 'frequency_ranking'];
    }
  }, {
    key: "user",
    get: function get() {
      return this.authUserStore.showData;
    }
  }, {
    key: "userIsLoaded",
    get: function get() {
      return (0, _utils.isPresent)(this.user.id);
    }
  }, {
    key: "targetLanguage",
    get: function get() {
      var _this2 = this;
      if (!this.userIsLoaded) {
        return {};
      }
      var tl = this.user.targetLanguages.find(function (item) {
        return item.languageId === _this2.targetLanguageId;
      });
      return tl || this.user.defaultTargetLanguage;
    }
  }, {
    key: "sortWithDirection",
    get: function get() {
      var sort = this.sort;
      if (this.sortDirection === 'desc') {
        sort = "-".concat(sort);
      }
      return sort;
    }
  }, {
    key: "showSpinner",
    get: function get() {
      return this.store.requestCounter > 0;
    }
  }, {
    key: "showWordListSpinner",
    get: function get() {
      return this.wordListLoading;
    }
  }, {
    key: "languagesStringFormatted",
    get: function get() {
      if ((0, _utils.isPresent)(this.languagesEnable) && (0, _utils.isPresent)(this.user.languageId)) {
        return "".concat(this.languagesWithWithout, " ").concat(this.user.languageId.startsWith('EN') ? 'English' : _constants.Languages[this.user.languageId]);
      }
    }
  }, {
    key: "hasActiveFilter",
    get: function get() {
      return (0, _utils.isPresent)(this.filterSettings.filter(function (item) {
        return !item.hide && (0, _utils.isPresent)(item.value);
      }));
    }
  }, {
    key: "filters",
    get: function get() {
      var filters = {
        root: true,
        video_clip_id: true,
        language_id: this.targetLanguageId || 'DE'
      };
      (0, _lodash.each)(this.filterSettings.filter(function (item) {
        return (0, _utils.isPresent)(item.value);
      }), function (item) {
        filters[item.key] = item.filterValue || item.value;
      });
      if (this.searchQuery && this.searchQuery.match('"')) {
        filters['target_text'] = this.searchQuery.replace(/\"/g, '');
      } else if (this.searchQuery) {
        filters['target_text'] = "~".concat(this.searchQuery, "~");
      }
      return filters;
    }
  }, {
    key: "filterSettings",
    get: function get() {
      var _this3 = this;
      var settings = [{
        key: 'level_id',
        userKey: 'vocabLevelId',
        label: 'Level',
        multiSelect: true,
        includeBlank: true,
        options: this.arrayToOptions(_constants.Constants.LEVELS.filter(function (item) {
          return item.abbreviation !== 'N';
        }), 'abbreviation'),
        filterType: 'select'
      }, {
        key: 'root_word_type_id',
        userKey: 'vocabWordTypeId',
        label: 'Word Type',
        multiSelect: true,
        includeBlank: true,
        options: this.arrayToOptions(_constants.Constants.VOCAB_WORD_TYPES, 'name'),
        filterType: 'select'
      }, {
        key: 'learned',
        userKey: 'vocabLearned',
        label: 'Learned',
        description: 'Words that you have marked as learned by clicking the "Star" icon.',
        includeBlank: true,
        options: [[true, 'Yes'], [false, 'No']],
        filterType: 'select'
      }, {
        key: 'reviewing',
        userKey: 'vocabReviewing',
        label: 'Reviewing',
        includeBlank: true,
        description: 'Words that you have added to a review deck.',
        options: [[true, 'Yes'], [false, 'No']],
        filterType: 'select'
      }, {
        key: 'seen',
        userKey: 'vocabSeen',
        label: 'Word Seen',
        includeBlank: true,
        description: 'Words that you have seen on Seedlang. Words seen in a sentence context also count as "Seen".',
        options: [[true, 'Yes'], [false, 'No']],
        filterType: 'select'
      }, {
        key: 'has_sentence',
        userKey: 'vocabHasSentence',
        label: 'Has Sentences',
        description: 'Words that have example sentences with a video recording.',
        includeBlank: true,
        options: [[true, 'Yes'], [false, 'No']],
        filterType: 'select'
      }, {
        key: 'has_highlighted_vocab_triad',
        userKey: 'vocabHasHighlightedVocabTriad',
        label: 'Has Highlighted Story',
        includeBlank: true,
        options: [[true, 'Yes'], [false, 'No']],
        filterType: 'select'
      }, {
        key: 'languages_string',
        userKey: 'vocabLanguagesWithWithout',
        label: 'Translations in Language',
        shortLabel: 'Translations',
        includeBlank: true,
        filterType: 'selectLanguage',
        showForLanguageId: ['DE'],
        options: [['with', 'Has Translations'], ['without', 'Has No Translations']],
        filterValue: "".concat(this.languagesWithWithout !== 'with' ? '!' : '').concat(this.user.languageId === 'EN2' ? 'EN' : this.user.languageId),
        customTag: this.languagesStringFormatted,
        showCustomTag: true
      }, {
        userKey: 'selectedWords',
        label: 'Words',
        value: this.selectedWordIds,
        customTag: "".concat(this.selectedWordIds.length, " Selected Word").concat(this.selectedWordIds.length === 1 ? '' : 's'),
        showCustomTag: true
      }];
      var filteredSettings = (0, _utils.isPresent)(this.selectedWordIds) ? settings.filter(function (item) {
        return item.userKey === 'selectedWords';
      }) : settings.filter(function (item) {
        return (!item.showForLanguageId || item.showForLanguageId.includes(_this3.targetLanguageId)) && item.userKey !== 'selectedWords';
      });
      return filteredSettings.map(function (item) {
        var hsh = {
          tagDisplay: item.showCustomTag ? item.customTag : (0, _utils.formatFilterTag)(item, _this3.filterCacheOrBackend(item.userKey)),
          value: _this3.filterCacheOrBackend(item.userKey)
        };
        return (0, _lodash.merge)(item, hsh);
      });
    }
  }, {
    key: "tabs",
    get: function get() {
      var list;
      list = [{
        name: 'trainers',
        label: 'Trainers',
        "default": this.showTrainersTab
      }, {
        name: 'wordList',
        label: 'Dictionary',
        "default": !this.showTrainersTab
      }];
      if (this.layout.isNative) {
        list.push({
          name: 'progress',
          label: 'Progress',
          "default": false
        });
      }
      return list;
    }
  }, {
    key: "languagesEnable",
    get: function get() {
      return this.filterCacheOrBackend('vocabLanguagesEnable');
    }
  }, {
    key: "languageId",
    get: function get() {
      return this.filterCacheOrBackend('languageId');
    }
  }, {
    key: "hasSentence",
    get: function get() {
      return this.filterCacheOrBackend('vocabHasSentence');
    }
  }, {
    key: "hasHighlightedVocabTriad",
    get: function get() {
      return this.filterCacheOrBackend('hasHighlightedVocabTriad');
    }
  }, {
    key: "languagesWithWithout",
    get: function get() {
      return this.filterCacheOrBackend('vocabLanguagesWithWithout');
    }
  }, {
    key: "searchQuery",
    get: function get() {
      return this.filterCacheOrBackend('vocabSearchQuery');
    }
  }, {
    key: "sort",
    get: function get() {
      return this.filterCacheOrBackend('vocabSort') || 'frequency_ranking';
    }
  }, {
    key: "sortDirection",
    get: function get() {
      return this.filterCacheOrBackend('vocabSortDirection');
    }
  }, {
    key: "expandTranslation",
    get: function get() {
      return this.filterCacheOrBackend('vocabExpandTranslation');
    }
  }, {
    key: "wordTypesAreAllNoun",
    get: function get() {
      return (0, _utils.isBlank)(this.selectedWords.filter(function (item) {
        return item.wordType.abbreviation !== 'noun';
      }));
    }
  }, {
    key: "showNounButton",
    get: function get() {
      return this.wordTypesAreAllNoun && (0, _utils.isPresent)(this.selectedWordIds) || (0, _utils.isBlank)(this.selectedWordIds) && this.wordType && this.wordType.name === 'Noun';
    }
  }, {
    key: "wordType",
    get: function get() {
      var _this4 = this;
      if (this.wordTypeId && this.wordTypeId !== 'any' && this.wordTypeStore.hasIndexData) {
        return this.wordTypeStore.indexData.find(function (item) {
          return item.id === _this4.wordTypeId;
        });
      }
    }
  }, {
    key: "showNoResultsMessage",
    get: function get() {
      return !this.showWordListSpinner && this.store.initialRequestReceived && !this.store.hasIndexData;
    }
  }, {
    key: "showColumnCheckbox",
    get: function get() {
      return this.user.isMember && this.store.initialRequestReceived && this.store.hasIndexData;
    }
  }, {
    key: "deckCreationDisabled",
    get: function get() {
      return !this.user.isMember;
    }
  }, {
    key: "deckButtonDisabled",
    get: function get() {
      var _Constants$REVIEW_CAR2, _Constants$REVIEW_CAR3, _Constants$REVIEW_CAR4;
      if (this.cardTypeId === ((_Constants$REVIEW_CAR2 = _constants.Constants.REVIEW_CARD_TYPES.find(function (item) {
        return item.slug === 'gender';
      })) === null || _Constants$REVIEW_CAR2 === void 0 ? void 0 : _Constants$REVIEW_CAR2.id)) {
        var _this$selectedWordsEx;
        return ((_this$selectedWordsEx = this.selectedWordsExcludedFromGenderTrainer) === null || _this$selectedWordsEx === void 0 ? void 0 : _this$selectedWordsEx.length) === this.selectedWords.length;
      }
      if (this.cardTypeId === ((_Constants$REVIEW_CAR3 = _constants.Constants.REVIEW_CARD_TYPES.find(function (item) {
        return item.slug === 'plural';
      })) === null || _Constants$REVIEW_CAR3 === void 0 ? void 0 : _Constants$REVIEW_CAR3.id)) {
        var _this$selectedWordsEx2;
        return ((_this$selectedWordsEx2 = this.selectedWordsExcludedFromPluralTrainer) === null || _this$selectedWordsEx2 === void 0 ? void 0 : _this$selectedWordsEx2.length) === this.selectedWords.length;
      }
      if (this.cardTypeId === ((_Constants$REVIEW_CAR4 = _constants.Constants.REVIEW_CARD_TYPES.find(function (item) {
        return item.slug === 'conjugation';
      })) === null || _Constants$REVIEW_CAR4 === void 0 ? void 0 : _Constants$REVIEW_CAR4.id)) {
        var _this$selectedWordsEx3;
        return ((_this$selectedWordsEx3 = this.selectedWordsExcludedFromConjugationTrainer) === null || _this$selectedWordsEx3 === void 0 ? void 0 : _this$selectedWordsEx3.length) === this.selectedWords.length;
      }
      return false;
    }
  }, {
    key: "selectedWordIds",
    get: function get() {
      return this.selectedWords.map(function (item) {
        return item.id;
      });
    }
  }, {
    key: "showSource",
    get: function get() {
      return !this.layout.isMobile;
    }
  }, {
    key: "showNounTrainerButtons",
    get: function get() {
      return (0, _utils.isBlank)(this.selectedWordIds) && this.wordType && this.wordType.name === 'Noun' || this.wordTypesAreAllNoun && (0, _utils.isPresent)(this.selectedWordIds);
    }
  }, {
    key: "showAddToReviewsButton",
    get: function get() {
      return (0, _utils.isPresent)(this.selectedWordIds);
    }
  }, {
    key: "page",
    get: function get() {
      if (this.overridePage) {
        return this.overridePage;
      } else if (this.pageFromParams) {
        return this.pageFromParams;
      }
      return 1;
    }
  }, {
    key: "showTrainersTab",
    get: function get() {
      return (0, _utils.isBlank)(this.vocabTab) || this.vocabTab === 'trainers';
    }
  }, {
    key: "pieChartTitle",
    get: function get() {
      var title;
      if (this.level && this.wordType) {
        title = "".concat(this.level.abbreviation, " ").concat(this.wordType.formattedName, "s");
      } else if (this.level) {
        title = "".concat(this.level.abbreviation, " Words");
      } else if (this.wordType) {
        title = "".concat(this.wordType.formattedName, "s");
      } else {
        title = 'Words';
      }
      return "".concat(title, " Progress");
    }
  }, {
    key: "pieChartData",
    get: function get() {
      var counts = this.wordStore.metaData;
      if (!counts) return [{
        y: 0
      }];
      var unseenCount = counts.totalWordTypeLevelCount - counts.learnedCount - counts.seenCount;
      var ary = [{
        y: counts.learnedCount
      }];
      if (counts.seenCount > 0) {
        ary.push({
          y: counts.seenCount
        });
      }
      if (unseenCount > 0) {
        ary.push({
          y: unseenCount
        });
      }
      return ary;
    }
  }, {
    key: "colors",
    get: function get() {
      var ary = [_constants.Theme.green, '#969696'];
      if (this.wordStore.metaData && this.wordStore.metaData.seenCount > 0) {
        ary.splice(1, 0, _constants.Theme.orange);
      }
      return ary;
    }
  }, {
    key: "reviewDecks",
    get: function get() {
      return this.reviewDeckStore.indexData;
    }
  }, {
    key: "filteredReviewDecks",
    get: function get() {
      var _this5 = this;
      return this.reviewDeckStore.indexData.filter(function (item) {
        return item.languageId === _this5.targetLanguageId && !item.archived;
      });
    }
  }, {
    key: "archivedReviewDecks",
    get: function get() {
      var _this6 = this;
      return this.reviewDeckStore.indexData.filter(function (item) {
        return item.languageId === _this6.targetLanguageId && item.archived;
      });
    }
  }, {
    key: "selectedWordsAreNouns",
    get: function get() {
      return (0, _utils.isPresent)(this.selectedWords) && this.selectedWords.filter(function (item) {
        var _item$wordType;
        return ((_item$wordType = item.wordType) === null || _item$wordType === void 0 ? void 0 : _item$wordType.id) === 'd5c5fcef-bb92-48a8-b00b-e7c71cb33068';
      }).length === this.selectedWords.length;
    }
  }, {
    key: "selectedWordsAreVerbs",
    get: function get() {
      return (0, _utils.isPresent)(this.selectedWords) && this.selectedWords.filter(function (item) {
        var _item$wordType2;
        return ((_item$wordType2 = item.wordType) === null || _item$wordType2 === void 0 ? void 0 : _item$wordType2.id) === '4c4389c1-f805-4d1c-ba45-6721cf400aef';
      }).length === this.selectedWords.length;
    }
  }, {
    key: "cardTypeOptions",
    get: function get() {
      var _this$selectedWordsEx4;
      var options = [this.getCardTypeOption('vocab_word_translate'), this.getCardTypeOption('vocab_word_comprehend'), this.getCardTypeOption('vocab_word_options')];
      if (this.selectedWordsAreVerbs && !(((_this$selectedWordsEx4 = this.selectedWordsExcludedFromConjugationTrainer) === null || _this$selectedWordsEx4 === void 0 ? void 0 : _this$selectedWordsEx4.length) === this.selectedWords.length)) {
        options.push(this.getCardTypeOption('conjugation'));
      }
      if (this.selectedWordsAreNouns) {
        var _this$selectedWordsEx5, _this$selectedWordsEx6;
        if (!(((_this$selectedWordsEx5 = this.selectedWordsExcludedFromGenderTrainer) === null || _this$selectedWordsEx5 === void 0 ? void 0 : _this$selectedWordsEx5.length) === this.selectedWords.length)) {
          options.push(this.getCardTypeOption('gender'));
        }
        if (this.targetLanguageId === 'DE' && !(((_this$selectedWordsEx6 = this.selectedWordsExcludedFromPluralTrainer) === null || _this$selectedWordsEx6 === void 0 ? void 0 : _this$selectedWordsEx6.length) === this.selectedWords.length)) {
          options.push(this.getCardTypeOption('plural'));
        }
      }
      return options;
    }
  }, {
    key: "getCardTypeOption",
    value: function getCardTypeOption(slug) {
      var cardType = _constants.Constants.REVIEW_CARD_TYPES.find(function (item) {
        return item.slug === slug;
      });
      return cardType ? [cardType.id, cardType.name] : null;
    }
  }, {
    key: "selectedWordsExcludedFromGenderTrainer",
    get: function get() {
      var _this$selectedWords;
      var excludedWordsTargetText = (_this$selectedWords = this.selectedWords) === null || _this$selectedWords === void 0 ? void 0 : _this$selectedWords.filter(function (item) {
        return item.hideFromGenderTrainer;
      }).map(function (item) {
        return item.targetTextWithDefiniteArticle;
      });
      if (this.selectedWordsAreNouns && (excludedWordsTargetText === null || excludedWordsTargetText === void 0 ? void 0 : excludedWordsTargetText.length) > 0) {
        return excludedWordsTargetText;
      }
      return null;
    }
  }, {
    key: "selectedWordsExcludedFromPluralTrainer",
    get: function get() {
      var _this$selectedWords2;
      var excludedWordsTargetText = (_this$selectedWords2 = this.selectedWords) === null || _this$selectedWords2 === void 0 ? void 0 : _this$selectedWords2.filter(function (item) {
        return item.hideFromPluralTrainer || item.noPlural;
      }).map(function (item) {
        return item.targetTextWithDefiniteArticle;
      });
      if (this.selectedWordsAreNouns && (excludedWordsTargetText === null || excludedWordsTargetText === void 0 ? void 0 : excludedWordsTargetText.length) > 0) {
        return excludedWordsTargetText;
      }
      return null;
    }
  }, {
    key: "selectedWordsExcludedFromConjugationTrainer",
    get: function get() {
      var _this$selectedWords3;
      var excludedWordsTargetText = (_this$selectedWords3 = this.selectedWords) === null || _this$selectedWords3 === void 0 ? void 0 : _this$selectedWords3.filter(function (item) {
        return item.hideFromConjugationTrainer || item.conjugatedVerbStringsCount === 0;
      }).map(function (item) {
        return item.targetText;
      });
      if (this.selectedWordsAreVerbs && (excludedWordsTargetText === null || excludedWordsTargetText === void 0 ? void 0 : excludedWordsTargetText.length) > 0) {
        return excludedWordsTargetText;
      }
      return null;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.disposer && this.disposer();
    }
  }, {
    key: "activeFilter",
    value: function activeFilter(value) {
      return (0, _utils.isPresent)(value) && value !== 'any';
    }
  }]);
}(_root_state["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "filterCache", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "selectedWords", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "caretPosition", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "allToggleSelected", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "userRequestIsPending", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "targetLanguageRequestIsPending", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "queuedUserData", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "queuedTargetLanguageData", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "vocabTab", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "tabsPreviouslyTrainers", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "deckId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "worksheetId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "cardTypeId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "filteredItemsCount", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "showFilterOptions", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "overridePage", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "pageFromParams", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "learnedByLevel", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "learnedByLevelLoading", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "updatedDeviceLanguageId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "targetLanguageId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "defaultReviewDeckId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "newReviewDeckName", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "createReviewsIsSlow", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "createReviewsFinished", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "wordVideoClips", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "wordListLoading", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "store", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "store"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "words", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "words"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "noFiltersSelectedMessage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "noFiltersSelectedMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "user", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "user"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userIsLoaded", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userIsLoaded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "targetLanguage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "targetLanguage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sortWithDirection", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sortWithDirection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showSpinner", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showSpinner"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showWordListSpinner", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showWordListSpinner"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "languagesStringFormatted", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "languagesStringFormatted"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasActiveFilter", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasActiveFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "filters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "filters"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "filterSettings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "filterSettings"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tabs", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "tabs"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "languagesEnable", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "languagesEnable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "languageId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "languageId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasSentence", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasSentence"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasHighlightedVocabTriad", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasHighlightedVocabTriad"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "languagesWithWithout", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "languagesWithWithout"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "searchQuery", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "searchQuery"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sort", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sort"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sortDirection", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sortDirection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "expandTranslation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "expandTranslation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "wordTypesAreAllNoun", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "wordTypesAreAllNoun"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showNounButton", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showNounButton"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "wordType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "wordType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showNoResultsMessage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showNoResultsMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showColumnCheckbox", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showColumnCheckbox"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deckCreationDisabled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "deckCreationDisabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deckButtonDisabled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "deckButtonDisabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedWordIds", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedWordIds"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showSource", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showSource"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showNounTrainerButtons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showNounTrainerButtons"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showAddToReviewsButton", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showAddToReviewsButton"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "page", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "page"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showTrainersTab", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showTrainersTab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pieChartTitle", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pieChartTitle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pieChartData", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pieChartData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "colors", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "colors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reviewDecks", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "reviewDecks"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "filteredReviewDecks", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "filteredReviewDecks"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "archivedReviewDecks", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "archivedReviewDecks"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedWordsAreNouns", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedWordsAreNouns"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedWordsAreVerbs", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedWordsAreVerbs"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardTypeOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardTypeOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedWordsExcludedFromGenderTrainer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedWordsExcludedFromGenderTrainer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedWordsExcludedFromPluralTrainer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedWordsExcludedFromPluralTrainer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedWordsExcludedFromConjugationTrainer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedWordsExcludedFromConjugationTrainer"), _class.prototype), _class);
var _default = exports["default"] = new VocabUI();